module.exports = __webpack_public_path__ + "static/media/author.6ea2ec78.md";